module.exports = __webpack_public_path__ + "0f40ff46.png";